import { Fetcher } from '@pp/core/src/api/Fetcher';

import type { ChartsDataType } from './types';

export interface FetchChartsDataParams {
  JSESSIONID: string;
  tableId: string;
  url: string;
  numberOfGames: number;
  force: boolean;
}

export const fetchChartsData = ({
  JSESSIONID,
  tableId,
  numberOfGames,
  url,
  force,
}: FetchChartsDataParams): Promise<ChartsDataType> => {
  return Fetcher.fetch<ChartsDataType>(url, {
    params: {
      JSESSIONID,
      tableId,
      numberOfGames,
    },
    force: force,
  });
};
